<template>
  <section class="home-services-section section-spacing">
    <div class="custom_container_store mt-3">
      <div class="row">
        <div class="col-lg-3 box_shadow_search">
          <img
            v-if="searchFranchise != ''"
            src="@/assets/imgs/svg/red-cross.svg"
            alt=""
            class="cross_icon"
            @click="clearSearch()"
          />
          <input
            type="text"
            v-model="searchFranchise"
            placeholder="Search Offices..."
            class="searchBar w-100 mb-0"
          />
          <div class="store_count mb-1">
            Offices: {{ filteredFranchiseList.length }}
          </div>
        </div>
        <div
          class="col-lg-4 d-flex align-items-center w-100 flex-wrap mobie_view_btn_wrapper"
        >
          <button
            v-for="(elem, index) in areaName"
            @click="handleButtonClick(elem.area)"
            :key="index"
            :class="
              elem.area == searchFranchise
                ? `btn-secondary-red`
                : `btn-secondary-white`
            "
            style="padding: 0.3rem"
            :style="elem.area != searchFranchise ? 'box-shadow:none' : ''"
          >
            {{ elem.area }}
          </button>
        </div>
      </div>

      <b-tabs
        v-model="tabIndex"
        pills
        card
        vertical
        justified
        class="custom-vertical-tabs map_tabs_custom"
        nav-wrapper-class="col-12 col-lg-3"
        :active-nav-item-class="tabsActive ? 'tab-active' : ''"
        align="center"
        style="height: 100%"
        v-if="filteredFranchiseList.length > 0"
      >
        <template v-for="(elem, index) in filteredFranchiseList">
          <b-tab no-body :active="elem[0]" class="custom-tab" :key="index">
            <template #title>
              <div class="custom-tab-title">
                <h4 class="h4 tabs-title custom_responsive_margin_">
                  {{ elem.name }}
                </h4>

                <p class="para custom_responsive_margin_">
                  <!-- <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="17"
                    viewBox="0 0 512.000000 512.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      fill="#427CEA"
                      stroke="none"
                    >
                      <path
                        d="M2430 5114 c-229 -26 -360 -54 -508 -109 -392 -147 -720 -416 -943 -775 -210 -339 -307 -778 -259 -1170 78 -631 528 -1501 1274 -2465 176 -228 403 -501 455 -548 69 -62 153 -62 222 0 52 47 279 320 455 548 671 867 1102 1655 1238 2267 35 157 46 259 46 423 -1 480 -193 939 -540 1285 -286 287 -623 460 -1020 525 -94 15 -352 27 -420 19z m247 -925 c373 -50 682 -318 783 -679 27 -95 37 -286 21 -390 -47 -296 -241 -556 -516 -690 -162 -79 -328 -109 -497 -90 -132 15 -199 34 -313 90 -275 134 -469 394 -516 690 -16 104 -6 295 21 390 125 446 566 741 1017 679z"
                      />
                    </g>
                  </svg> -->
                  <img
                    src="@/assets/imgs/franchise/Poniter.svg"
                    class="locator_pointer_img"
                  />
                  {{ elem.address }}
                </p>
                <div class="d-flex flex-wrap justify-content-between">
                  <p
                    class="para custom_responsive_margin_"
                    v-if="elem.phone != ''"
                  >
                    <img
                      src="@/assets/imgs/franchise/Phone.svg"
                      class="locator_pointer_img"
                    />
                    <!-- <svg
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5569 10.8063L12.1019 11.2375C12.1019 11.2375 11.0189 12.2617 8.06386 9.46502C5.10886 6.66833 6.19186 5.64408 6.19186 5.64408L6.47786 5.37183C7.18486 4.70359 7.25186 3.62985 6.63486 2.84548L5.37486 1.24342C4.61086 0.27248 3.13586 0.143974 2.26086 0.97213L0.690856 2.4571C0.257856 2.86832 -0.032144 3.39949 0.002856 3.98967C0.092856 5.50034 0.810856 8.74919 4.81486 12.5397C9.06186 16.5586 13.0469 16.7185 14.6759 16.5738C15.1919 16.5281 15.6399 16.2787 16.0009 15.9361L17.4209 14.592C18.3809 13.6848 18.1109 12.1284 16.8829 11.4935L14.9729 10.5045C14.1669 10.0885 13.1869 10.2104 12.5569 10.8063Z"
                        fill="#427CEA"
                      />
                    </svg> -->
                    <a
                      :href="'tel:' + elem.phone"
                      :style="
                        tabIndex == index ? 'color: #212529' : 'color: #212529'
                      "
                    >
                      {{ elem.phone }}</a
                    >
                  </p>
                  <p class="para" v-if="elem.email != ''">
                    <img
                      src="@/assets/imgs/franchise/email_2099199.svg"
                      class="locator_pointer_img"
                    />
                    <!-- <svg
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="17"
                      viewBox="0 0 512.000000 512.000000"
                      preserveAspectRatio="xMidYMid meet"
                      class="locator_pointer_img"
                    >
                      <g
                        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        fill="#427CEA"
                        stroke="none"
                      >
                        <path
                          d="M366 4464 c-255 -62 -415 -322 -351 -569 20 -75 57 -143 107 -195 45 -46 2175 -1471 2253 -1506 119 -54 260 -52 382 5 95 45 2182 1442 2235 1496 249 254 113 686 -243 770 -94 22 -4291 21 -4383 -1z"
                        />
                        <path
                          d="M0 2236 c0 -810 3 -1181 11 -1218 37 -176 179 -320 360 -363 94 -22 4267 -22 4372 0 182 38 329 184 366 363 13 61 16 2386 3 2380 -4 -1 -487 -323 -1074 -715 -587 -392 -1099 -729 -1139 -748 -110 -56 -204 -77 -339 -77 -135 0 -229 21 -339 77 -40 19 -552 356 -1139 748 -587 392 -1070 714 -1074 715 -5 2 -8 -521 -8 -1162z"
                        />
                      </g>
                    </svg> -->
                    <a
                      :href="'mailto:' + elem.email"
                      :style="
                        tabIndex == index ? 'color: #212529' : 'color: #212529'
                      "
                    >
                      {{ elem.email }}</a
                    >
                  </p>
                </div>

                <div
                  class="d-flex justify-content-around align-items-center mobile_responsive_alignment flex-wrap"
                >
                  <button
                    v-if="elem.know_more_path != ''"
                    @click="knowMoreRedirect(elem.know_more_path)"
                    class="btn know_more_btn"
                    style="padding: 0.5rem"
                  >
                    Know More
                  </button>
                  <img
                    src="@/assets/imgs/franchise/google-maps_2642502.png"
                    @click.prevent="preventDefaultAction(elem.directionUrl)"
                    style="width: 10%"
                    class="destop_map_icon_logo"
                  />
                </div>
              </div>
            </template>

            <div class="text-center mt-2 mt-lg-0">
              <iframe
                :src="elem.iframe_src"
                class="map_iframe"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </b-tab>
        </template>
      </b-tabs>
      <div class="error" v-if="filteredFranchiseList.length == 0">
        <p>Franchise Not Found</p>
      </div>
    </div>
    <!-- <div class="text-center mt-4">
      <button
        @click="() => $router.push({ path: '/abroad-counselling' })"
        class="btn btn-secondary-red"
      >
        Know More
      </button>
    </div> -->
  </section>
</template>

<script>
export default {
  name: "MapFranchiseService",
  data() {
    return {
      searchFranchise: "",
      baseUrl: "",
      tabsActive: true,
      percentageValue: 0,
      tabIndex: 0,
      tabs: [true, false, false, false],
      OnclickFranchiseArea: "",
      // intVal: "",
      franchiseData: [
        {
          name: "Mumbai Office",
          area: "Mumbai",
          address:
            " 7C/602, Spring Leaf Lokhandwala Township Akurli Road Next to HDFC Bank Kandivali East Mumbai-400101",
          phone: "",
          email: "kazi.shabana@aliff.in",
          director_name: "Shabana Kazi",
          know_more_path: "/mumbai-micro-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.9578707933333!2d72.86803227609911!3d19.19704234815966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b715b46c8db1%3A0xf9e6d841df4645e0!2sSpring%20Leaf%20Tower%205!5e0!3m2!1sen!2sin!4v1732335572765!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Spring+Leaf+Tower+5,+Spring+Leaf+5+Tower,+next+to+HDFC+Bank,+Lokhandwala+Twp,+Kandivali+East,+Mumbai,+Maharashtra+400101/@19.1970423,72.8680323,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3be7b715b46c8db1:0xf9e6d841df4645e0!2m2!1d72.8706082!2d19.1970669?entry=ttu&g_ep=EgoyMDI0MTExOS4yIKXMDSoASAFQAw%3D%3D",
          near_by: "",
        },
        {
          name: "Chennai Office, Tamil Nadu",
          area: "Tamil Nadu",
          address:
            " C305 Isha Aabhirupam,Vengambakkam Main Road, Kaspapuram,Selaiyur Chennai 600 126",
          phone: "+91 9176656580",
          email: "radha@aliff.in",
          director_name: "Radha Kanan",
          know_more_path: "/chennai-office-radha",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.294760308796!2d80.13434187602256!3d12.888758316687156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5258d153e1df01%3A0x36938cdb08b7d8f0!2sIsha%20Aabhirupam!5e0!3m2!1sen!2sin!4v1732335694197!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//V4QP%2BCMC+Isha+Aabhirupam,+S.No.+1%2F1,+Vengambakkam+Main+Road,+Near+Mappedu+Junction,+Kaspapuram,+Selaiyur,+Mappedu,+Tiruvanchery,+Selaiyur,+Chennai,+Tamil+Nadu+600073/@12.8887583,80.1343419,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a5258d153e1df01:0x36938cdb08b7d8f0!2m2!1d80.1369165!2d12.8887507?entry=ttu&g_ep=EgoyMDI0MTExOS4yIKXMDSoASAFQAw%3D%3D",
          near_by: "",
        },
        {
          name: "Chennai Office, Tamil Nadu",
          area: "Tamil Nadu",
          address: "Chennai",
          phone: "+91 9916557345",
          email: "meena@aliff.in",
          director_name: "Meena Surendhar",
          know_more_path: "/chennai-office-meena",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.1700847121574!2d48.02307477487692!3d29.336010751789292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9cf41f144621%3A0xc9f38b62d94554a4!2sAl-Rehab%20Complex%2C%20Tunisia%20St%2C%20Kuwait%20City%2C%20Kuwait!5e0!3m2!1sen!2sin!4v1710355818769!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Al-Rehab+Complex+Tunisia+St+Kuwait+City+Kuwait/@29.3360061,48.0256497,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3fcf9cf41f144621:0xc9f38b62d94554a4",
          near_by: "",
        },
        {
          name: "Ghana Office",
          area: "Ghana",
          address: "Ghana",
          phone: "+233 24 451 1709",
          email: "ghana@aliff.in",
          director_name: "Puja Gokaldas",
          know_more_path: "/ghana-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.1700847121574!2d48.02307477487692!3d29.336010751789292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9cf41f144621%3A0xc9f38b62d94554a4!2sAl-Rehab%20Complex%2C%20Tunisia%20St%2C%20Kuwait%20City%2C%20Kuwait!5e0!3m2!1sen!2sin!4v1710355818769!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Al-Rehab+Complex+Tunisia+St+Kuwait+City+Kuwait/@29.3360061,48.0256497,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3fcf9cf41f144621:0xc9f38b62d94554a4",
          near_by: "",
        },
        {
          name: "Solapur Office",
          area: "Solapur",
          address:
            "603, Rameshwar Building, Haripadam Residency, Solapur 413002.",
          phone: "+91 9028413886",
          email: "harshada@aliff.in",
          director_name: "Harshada Patil",
          know_more_path: "/solapur-micro-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d776.7696984621936!2d75.89775146041204!3d17.688357196679444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d078210007c7%3A0x7a9fecbcaeed8844!2sHari%20Padam%20Residency!5e0!3m2!1sen!2sin!4v1732182441298!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//MVQX%2B87F+Hari+Padam+Residency,+Mane+Wasti,+New+Budhwar+Peth,+Solapur,+Maharashtra+413002/@17.6883298,75.8956073,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc5d078210007c7:0x7a9fecbcaeed8844!2m2!1d75.8981737!2d17.6883387?entry=ttu&g_ep=EgoyMDI0MTExOC4wIKXMDSoASAFQAw%3D%3D",
          near_by: "",
        },
        {
          name: "Solapur Office",
          area: "Solapur",
          address: "North Sadar Bazaar, Solapur ",
          phone: "+91 9890355881",
          email: "jahaangeer@aliff.in",
          director_name: "Jahaangeer Bagban",
          know_more_path: "/solapur-office-jahaangeer",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3450.1821476220803!2d75.90736189029224!3d17.660899360504743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5db1d9ab1e823%3A0x3463547da10df2cc!2sSolapur%20north%20Sadar%20Bazar!5e0!3m2!1sen!2sin!4v1732605567180!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//MW66%2BG4G+Solapur+north+Sadar+Bazar,+South+Sadar+Bazar,+Jawaharlal+Housing+Society,+Lashkar,+Solapur,+Maharashtra+413003/@17.6608994,75.9073619,17.14z/data=!4m18!1m8!3m7!1s0x3bc5db1d9ab1e823:0x3463547da10df2cc!2sSolapur+north+Sadar+Bazar!8m2!3d17.6613204!4d75.9103131!15sChpOb3J0aCBTYWRhciBCYXphciwgU29sYXB1clobIhlub3J0aCBzYWRhciBiYXphciBzb2xhcHVykgEPYnVkZGhpc3RfdGVtcGxlmgEkQ2hkRFNVaE5NRzluUzBWSlEwRm5TVU51ZFdOcFUyaDNSUkFC4AEA-gEECAAQDA!16s%2Fg%2F11s5k3pg7h!4m8!1m0!1m5!1m1!1s0x3bc5db1d9ab1e823:0x3463547da10df2cc!2m2!1d75.910308!2d17.6612994!3e2?entry=ttu&g_ep=EgoyMDI0MTExOS4yIKXMDSoASAFQAw%3D%3D",
          near_by: "",
        },
      ],
      areaName: [
        { area: "Mumbai" },
        // { area: "Thane" },
        // { area: "Pune" },
        // { area: "Vadodara" },
        // { area: "Raipur" },
        { area: "Solapur" },
        // { area: "Navi Mumbai" },
        // { area: "Karnataka" },
        { area: "Tamil Nadu" },
        // { area: "Kolkata" },
        // { area: "Dubai" },
        // { area: "Kuwait" },
        { area: "Ghana" },
      ],
    };
  },
  // watch: {
  //   franchiseData: {
  //     deep: true,
  //     handler(newValue, oldValue) {
  //       console.log(newValue, "newValue");
  //     },
  //   },
  // },
  computed: {
    filteredFranchiseList() {
      console.log(this.OnclickFranchiseArea, "this.OnclickFranchiseArea");
      return this.franchiseData.filter((val) => {
        return (
          val.name.toLowerCase().includes(this.searchFranchise.toLowerCase()) ||
          val.address
            .toLowerCase()
            .includes(this.searchFranchise.toLowerCase()) ||
          val.near_by.toLowerCase().includes(this.searchFranchise.toLowerCase())
        );
      });
    },
    scrollWin() {
      window.scrollBy(0, 100);
    },
  },

  methods: {
    handleButtonClick(value) {
      this.searchFranchise = value;

      // Store the selected value in the variable
    },

    preventDefaultAction(url) {
      window.open(url, "_blank");
    },
    knowMoreRedirect(url) {
      console.log("Working", url);
      if (!url.includes("abroad-counselling")) {
        const routeData = this.$router.resolve({ path: url });
        window.open(routeData.href, "_blank");
      } else {
        window.open(url, "_blank");
      }
    },
    clearSearch() {
      console.log("clicked");
      this.searchFranchise = "";
    },
    tabsTimer() {
      const r = document.querySelector(":root");
      let tabNo = 0;
      let intVal = "";
      intVal = setInterval(() => {
        if (this.percentageValue < 100) {
          this.percentageValue += 1;
          // r.style.setProperty("--percentage", this.percentageValue + "%");
        } else {
          this.percentageValue = 0;
          // console.log(tabNo);
          this.$set(this.tabs, tabNo, false);
          this.$set(this.tabs, (tabNo + 1) % 4, true);

          if (tabNo == 3) {
            tabNo = 0;
            this.$set(this.tabs, tabNo, true);
          } else {
            tabNo = tabNo + 1;
          }

          // console.log(this.tabs, tabNo);

          if (this.$route.name != "home") {
            clearInterval(this.intVal);
          }
          // intVal();
        }
      }, 50);
    },
  },
  beforeMount() {
    if (this.$route.name == "home") {
      this.tabsTimer();
    }
    this.baseUrl = window.location.origin;
  },
};
</script>

<style>
.locator_pointer_img {
  width: auto !important;
}
.map_tabs_custom .nav-pills {
  height: 500px !important;
  flex-wrap: nowrap !important;
  overflow-y: scroll !important;
  padding-left: 0px;
  padding-right: 0.5rem;
  padding-top: 0px;
}
/* .searchBar {
    background: #eaf4fe;
    border: none;
    border-radius: 7px;
    padding: 10px;
  } */

.error p {
  color: #000;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
}
.cross_icon {
  position: absolute;
  right: 30px;
  bottom: 60px;
  cursor: pointer;
}
.map_iframe {
  width: 100%;
  height: 500px;
}
p {
  font-size: 14px !important;
}
.custom_responsive_margin_ {
  margin: 0px;
}
@media (max-width: 767px) {
  .map_tabs_custom .nav-pills {
    height: 320px !important;

    flex-wrap: wrap !important;
    overflow-x: scroll !important;
    overflow-y: hidden !important;
    gap: 20px;
  }
  .mobile_responsive_alignment {
    flex-wrap: wrap;
    gap: 20px;
  }
}
@media (max-width: 991px) {
  .custom_responsive_margin_ {
    margin-bottom: 12px;
  }
  p {
    font-size: 15px !important;
  }
  .error p {
    font-size: 25px;
  }
  .map_iframe {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/MicroFranchise.vue